/* eslint-disable no-param-reassign */
// eslint-disable-next-line import/no-extraneous-dependencies
import { produce } from 'immer';
import { quickViewPipClickThrough } from '../../../analytics';

export default (set, get, productType) => set(produce(get(), (draft) => {
  if (!draft.digitalData) {
    draft.digitalData = { event: [] };
  }

  const trackQuickViewPipClickThrough = { productType };

  draft.digitalData.quickViewSectionViewed = trackQuickViewPipClickThrough;

  quickViewPipClickThrough(trackQuickViewPipClickThrough);
}), false, { type: 'TRACK_QUICK_VIEW_PIP_CLICK_THROUGH' });
